// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__26iXX","footer":"ModalCreateQualiphyProcedure_footer__1zS3z","additionData":"ModalCreateQualiphyProcedure_additionData__2GpSn"};